import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { EMPTY_PIXEL } from '~/const/images';
import { formatPrismicImage } from '~/helpers/image-helper';
import TitleSection from '~/components/atoms/Editorial/TitleSection.vue';
import SubtitleSection from '~/components/atoms/Editorial/SubtitleSection.vue';
import MdmVideo from '~/components/atoms/Global/MdmVideo.vue';
import MdmLink from '~/components/atoms/MdmLink.vue';
export default {
  name: 'CollectionVideoHeader',
  components: {
    TitleSection: TitleSection,
    SubtitleSection: SubtitleSection,
    MdmVideo: MdmVideo,
    MdmLink: MdmLink
  },
  props: {
    payload: {
      type: Object,
      required: true
    }
  },
  computed: {
    currentPayload: function currentPayload() {
      var _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23;

      return {
        background: ((_ref23 = this.payload) != null ? (_ref23 = _ref23.primary) != null ? _ref23.background_color : _ref23 : _ref23) || '',
        image: {
          formatted: "".concat(formatPrismicImage((_ref22 = this.payload) != null ? (_ref22 = _ref22.primary) != null ? (_ref22 = _ref22.main_image) != null ? _ref22.url : _ref22 : _ref22 : _ref22, ['w_375']) || EMPTY_PIXEL, " 375w,\n                      ").concat(formatPrismicImage((_ref21 = this.payload) != null ? (_ref21 = _ref21.primary) != null ? (_ref21 = _ref21.main_image) != null ? _ref21.url : _ref21 : _ref21 : _ref21, ['w_375,dpr_2']) || EMPTY_PIXEL, " 750w,\n                      ").concat(formatPrismicImage((_ref20 = this.payload) != null ? (_ref20 = _ref20.primary) != null ? (_ref20 = _ref20.main_image) != null ? _ref20.url : _ref20 : _ref20 : _ref20, ['w_1440']) || EMPTY_PIXEL, " 1440w,\n                      ").concat(formatPrismicImage((_ref19 = this.payload) != null ? (_ref19 = _ref19.primary) != null ? (_ref19 = _ref19.main_image) != null ? _ref19.url : _ref19 : _ref19 : _ref19, ['w_1440,dpr_2']) || EMPTY_PIXEL, " 2880w\n                      ")
        },
        video: {
          background: ((_ref18 = this.payload) != null ? (_ref18 = _ref18.primary) != null ? _ref18.video_background_color : _ref18 : _ref18) || '',
          image: {
            small: formatPrismicImage((_ref17 = this.payload) != null ? (_ref17 = _ref17.primary) != null ? (_ref17 = _ref17.video_image) != null ? _ref17.url : _ref17 : _ref17 : _ref17, ['w_375']) || EMPTY_PIXEL,
            medium: formatPrismicImage((_ref16 = this.payload) != null ? (_ref16 = _ref16.primary) != null ? (_ref16 = _ref16.video_image) != null ? _ref16.url : _ref16 : _ref16 : _ref16, ['w_375,dpr_2']) || EMPTY_PIXEL,
            alt: ((_ref15 = this.payload) != null ? (_ref15 = _ref15.primary) != null ? _ref15.video_image_alt : _ref15 : _ref15) || ''
          },
          url: formatPrismicImage((_ref14 = this.payload) != null ? (_ref14 = _ref14.primary) != null ? (_ref14 = _ref14.video_url) != null ? _ref14.url : _ref14 : _ref14 : _ref14, [], '', 'video') || '',
          color: ((_ref13 = this.payload) != null ? (_ref13 = _ref13.primary) != null ? _ref13.video_play_color : _ref13 : _ref13) || '',
          tracking: {
            data: {
              event_category: ((_ref12 = this.payload) != null ? (_ref12 = _ref12.primary) != null ? _ref12.video_event_category : _ref12 : _ref12) || '',
              event_action: ((_ref11 = this.payload) != null ? (_ref11 = _ref11.primary) != null ? _ref11.video_event_action : _ref11 : _ref11) || '',
              event_label: ((_ref10 = this.payload) != null ? (_ref10 = _ref10.primary) != null ? _ref10.video_event_label : _ref10 : _ref10) || ''
            }
          }
        },
        paragraph: {
          title: ((_ref9 = this.payload) != null ? (_ref9 = _ref9.primary) != null ? (_ref9 = _ref9.title) != null ? _ref9[0] : _ref9 : _ref9 : _ref9) || '',
          subtitle: ((_ref8 = this.payload) != null ? (_ref8 = _ref8.primary) != null ? (_ref8 = _ref8.subtitle) != null ? _ref8[0] : _ref8 : _ref8 : _ref8) || '',
          text: ((_ref7 = this.payload) != null ? (_ref7 = _ref7.primary) != null ? (_ref7 = _ref7.text) != null ? (_ref7 = _ref7[0]) != null ? _ref7.text : _ref7 : _ref7 : _ref7 : _ref7) || '',
          button: {
            text: ((_ref6 = this.payload) != null ? (_ref6 = _ref6.primary) != null ? _ref6.button_text : _ref6 : _ref6) || '',
            url: ((_ref5 = this.payload) != null ? (_ref5 = _ref5.primary) != null ? (_ref5 = _ref5.button_url) != null ? _ref5.url : _ref5 : _ref5 : _ref5) || '',
            tracking: {
              data: {
                event_category: ((_ref4 = this.payload) != null ? (_ref4 = _ref4.primary) != null ? _ref4.button_event_category : _ref4 : _ref4) || '',
                event_action: ((_ref3 = this.payload) != null ? (_ref3 = _ref3.primary) != null ? _ref3.button_event_action : _ref3 : _ref3) || '',
                event_label: ((_ref2 = this.payload) != null ? (_ref2 = _ref2.primary) != null ? _ref2.button_event_label : _ref2 : _ref2) || ''
              }
            }
          }
        }
      };
    },
    isFullSize: function isFullSize() {
      var _ref;

      return ((_ref = this.payload) != null ? (_ref = _ref.primary) != null ? _ref.main_image_size : _ref : _ref) === 'full size';
    }
  }
};